/* eslint no-lonely-if: 0 */
import MaskedInput from 'react-text-mask'
// // import TextField from 'ddiForm/TextField'
// import { TextField } from '@material-ui/core'
import { phoneNumber } from 'ddiForm/validations'
import React from 'react'

export default function PhoneNumberMask(props) {
  const { inputRef, ...rest } = props
  // console.log('phoneNumberProps', props)
  const onBlur = e => {
    let value = e.target.value
    const keys = Array.from(value)
    const digitCount = keys.reduce((acc, next) => {
      if (Number.isInteger(parseInt(next, 10))) {
        acc += 1
      }
      return acc
    }, 0)

    if (props.validate) {
      if (digitCount === 10) {
        value = value.replace(/[()]/g, '').replace(/[\s]/g, '-')
      }
    } else {
      if (digitCount === 10) {
        value = value.replace(/[()]/g, '').replace(/[\s]/g, '-')
      } else {
        value = ''
      }
    }

    const target = {
      target: {
        value
      }
    }
    props.onBlur(target)
  }
  return (
    <MaskedInput
      {...rest}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={[
        '(',
        /[0-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={'\u2000'}
      onBlur={onBlur}
      showMask={!!props.value}
      style={props.style}
    />
  )
}

// const PhoneNumberTextField = props => (
//   <TextField
//     {...props}
//     InputProps={{
//       inputComponent: PhoneNCustom
//     }}
//   />
// )
// export default PhoneNumberTextField
